export default "__VITE_ASSET__DeXkvlTt__"